import Vue from 'vue';
import Router from 'vue-router';

//ENLACES ACERCA DE
import contacto from '@/components/Extras/contacto'
import sitioInteres from '@/components/Extras/sitioInteres';

//ENLACES APP BAR
//Inicio
import Inicio from '@/components/Inicio/principal';

//Directorio
import Organigrama from '@/components/Directorio/pagOrganigrama'

//Conóncenos
import marcoJuridico from '@/components/Conócenos/pagMarcoJuridico';
import MisionVision from '@/components/Conócenos/pagMYV';
import plantaAcademica from '@/components/Conócenos/pagPlantaAcademica';
import publicaciones from '@/components/Conócenos/pagPublicaciones';

//Oferta Educativa
import licenciaturas from '@/components/Oferta Educativa/licenciaturas';
//import agronomia from '@/components/Oferta Educativa/agronomia';
import fitotecnia from '@/components/Oferta Educativa/fitotecnia';
import zootecnia from '@/components/Oferta Educativa/zootecnia';
import fruticultura from '@/components/Oferta Educativa/fruticultura';

//Aspirantes
import admision from '@/components/Aspirantes/admision';

//Vinculacion
import bolsaDeTrabajo from '@/components/Vinculacion/bolsaDeTrabajo';
import convenios from '@/components/Vinculacion/convenios';

import infoDocente from '@/components/Conócenos/docentes/viewProfesores';

import asd from '@/components/Extras/sia.vue';

import Error from '@/components/Extras/error';

//import AgregarPersonaje from '@/components/AgregarPersonaje';
//import Personaje from '@/components/Personaje';
//import Registro from '@/components/Registro';
//import Login from '@/components/Login';
//import Luchadores from '@/components/Luchadores';
//import Objetos from '@/components/Objetos';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio,
    },
    {
      path: '/directorio',
      name: 'Orgranigrama',
      component: Organigrama,
    },
    {
      path: '/conocenos/marco-juridico',
      name: 'MarcoJuridico',
      component: marcoJuridico,
    },
    {
      path: '/conocenos/mision-vision',
      name: 'MisionVision',
      component: MisionVision,
    },
    {
      //path: '/conocenos/planta-academica',
      path: '/planta-academica',
      name: 'plantaAcademica',
      component: plantaAcademica,
    },
    {
      path: '/conocenos/planta-academica/profesores/:id',
      name: 'infoDocente',
      component: infoDocente,
    },
    {
      path: '/conocenos/publicaciones',
      name: 'publicaciones',
      component: publicaciones,
    },
    {
      path: '/programas',
      name: 'licenciaturas',
      component: licenciaturas,
    },
    /*{
      path: '/oferta-educativa/:id',
      name: 'agronomia',
      component: agronomia,
    },*/
    {
      path: '/oferta-educativa/fitotecnia',
      name: 'fitotecnia',
      component: fitotecnia,
    },
    {
      path: '/oferta-educativa/zootecnia',
      name: 'zootecnia',
      component: zootecnia,
    },
    {
      path: '/oferta-educativa/fruticultura',
      name: 'fruticultura',
      component: fruticultura,
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: contacto
    },
    {
      path: '/sitio-interes',
      name: 'sitioInteres',
      component: sitioInteres
    },
    {
      path: '/aspirantes/admision',
      name: 'admision',
      component: admision
    },
    {
      path: '/vinculacion/bolsa-de-trabajo',
      name: 'bolsaDeTrabajo',
      component: bolsaDeTrabajo
    },
    {
      path: '/convenios',
      name: 'convenios',
      component: convenios
    },
    {
      path: '/sia/memorias',
      name: 'sia',
      component: asd
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'error',
      component: Inicio
    },
  ],
});
